import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import StudentProfileView from "../components/manage-user/StudentProfileView";

const StudentProfile = () => {
  return (
    <AdminLayout>
      <StudentProfileView />
    </AdminLayout>
  );
};

export default StudentProfile;
